import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const ShipIdentityType = () => {
return(
  <SettingsMetaData propertyName={"ShipIdentityType"} viewPropertyName={"Identity Type"} />
)
};

export default ShipIdentityType;